<div class="container-fluid glb-popup blog-form">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (loading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  @if (blogId) {
    <a pButton pRipple class="p-button-outlined" style="float:right;top:-35px;margin-right:50px;"
    href="https://www.kbmresorts.com/blog/{{blogId}}/preview" target="_blank">Preview</a>
  }

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown (onChange)="onTypeChange($event)" [disabled]="!!blogId" dropdownIcon="fa fa-caret-down" class="w-100" [options]="types" formControlName="type" optionLabel="name"
            optionValue="value"></p-dropdown>
            <label for="Type">Type</label>
            @for (validation of validationMessages.type; track validation) {
              <span>
                @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (form1?.get('type')?.value === 1) {
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown [autoDisplayFirst]="false" dropdownIcon="fa fa-caret-down" class="w-100" [options]="locationCategories" formControlName="locationId"
              optionLabel="name" optionValue="locationId" placeholder=""></p-dropdown>
              <label for="Select Location">Select Location</label>
              @for (validation of validationMessages.locationId; track validation) {
                <span>
                  @if (form1.get('locationId').hasError(validation.locationId) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                    <small class="p-invalid"
                      >{{validation?.locationId?.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }





        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="statuses"
            formControlName="status" optionLabel="name" optionValue="value"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        @if (blogId) {
          <div class="col-lg-6 mb-3">
            <span class="p-float-label w-100 mb-3">
              <p-multiSelect dropdownIcon="fa fa-caret-down" class="lead-select" [options]="developments"
                formControlName="blogDevelopmentAPIList" defaultLabel="Select Developments"
                optionLabel="addressDevelopmentName" [displaySelectedLabel]="true">
                <ng-template pTemplate="item" let-development>
                  <span>{{development.addressDevelopmentName}}{{getLocationName(development?.locationId)}}</span>
                </ng-template>
              </p-multiSelect>
              <label for="Select Statement Month">Select Developments</label>
              @for (validation of validationMessages.blogDevelopmentAPIList; track validation) {
                <span>
                  @if (form1.get('blogDevelopmentAPIList').hasError(validation.type) && (form1.get('blogDevelopmentAPIList').dirty || form1.get('blogDevelopmentAPIList').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (form1?.get('type')?.value === 2) {
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <p-calendar class="w-100" formControlName="statementMonth" view="month" dateFormat="mm/yy"
              [readonlyInput]="true" placeholder="Select Statement Month"></p-calendar>
              <label for="Select Statement Month">Select Statement Month</label>
              @for (validation of validationMessages.statementMonth; track validation) {
                <span>
                  @if (form1.get('statementMonth').hasError(validation.statementMonth) && (form1.get('statementMonth').dirty || form1.get('statementMonth').touched)) {
                    <small class="p-invalid"
                      >{{validation?.statementMonth?.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }


        @if (blogId) {
          <div style="padding-bottom: 20px" class="col-lg-12">
            <app-blog-development-list [blogId]="blogId" [showFilter]="false"
            [showPagination]="false" [outlineNewButton]="false"></app-blog-development-list>
          </div>
        }



        @if (form1?.get('type')?.value === 1) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <textarea formControlName="leadDescription" id="leadDescription" [rows]="2"
              pInputTextarea></textarea>
              <label for="leadDescription">Lead Description</label>
              @for (validation of validationMessages.leadDescription; track validation) {
                <span>
                  @if (form1.get('leadDescription').hasError(validation.type) && (form1.get('leadDescription').dirty || form1.get('leadDescription').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        <div class="col-lg-12">
          <label for="description"><strong>Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
					<editor formControlName="description" id="description" [init]="{
										selector: 'textarea#open-source-plugins',
			  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
			  editimage_cors_hosts: ['picsum.photos'],
										height: 700,
										base_url: '/tinymce',
										suffix: '.min',
										menubar: 'file edit view insert format tools table tc help',
			  toolbar: 'undo redo | aidialog aishortcuts | blocks fontsizeinput | bold italic | align numlist bullist | link image | table media pageembed | lineheight  outdent indent | strikethrough forecolor backcolor formatpainter removeformat | charmap emoticons checklist | code fullscreen preview | save print export | pagebreak anchor codesample footnotes mergetags | addtemplate inserttemplate | addcomment showcomments | ltr rtl casechange | spellcheckdialog a11ycheck',
			  autosave_ask_before_unload: true,
			  autosave_interval: '30s',
			  autosave_prefix: '{path}{query}-{id}-',
			  autosave_restore_when_empty: false,
			  autosave_retention: '2m',
			  image_advtab: true,
			  link_list: [
			    { title: 'My page 1', value: 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/' },
			    { title: 'My page 2', value: 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/' }
			  ],
			  image_list: pictureList,
			  image_class_list: [
			    { title: 'None', value: '' },
			    { title: 'Some class', value: 'class-name' }
			  ],
			  importcss_append: true,
			  template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
			  template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
			  image_caption: true,
			  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
			  noneditable_class: 'mceNonEditable',
			  toolbar_mode: 'sliding',
			  contextmenu: 'link image table',
			  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
									}">
            </editor>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (form1?.get('type')?.value === 1) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <textarea formControlName="keywordsForSeo" id="keywordsForSeo" [rows]="1" pInputTextarea></textarea>
              <label for="keywordsForSeo">Keywords For SEO</label>
              @for (validation of validationMessages.keywordsForSeo; track validation) {
                <span>
                  @if (form1.get('keywordsForSeo').hasError(validation.type) && (form1.get('keywordsForSeo').dirty || form1.get('keywordsForSeo').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }
        @if (form1?.get('type')?.value === 1) {
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="urlLinkTitle" id="urlLinkTitle" type="text" pInputText>
              <label for="urlLinkTitle">URL Link Title</label>
              @for (validation of validationMessages.urlLinkTitle; track validation) {
                <span>
                  @if (form1.get('urlLinkTitle').hasError(validation.type) && (form1.get('urlLinkTitle').dirty || form1.get('urlLinkTitle').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }
        @if (form1?.get('type')?.value === 1) {
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="urlLink" id="urlLink" type="text" pInputText>
              <label for="urlLink">URL Link</label>
              @for (validation of validationMessages.urlLink; track validation) {
                <span>
                  @if (form1.get('urlLink').hasError(validation.type) && (form1.get('urlLink').dirty || form1.get('urlLink').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (blogId && form1?.get('type')?.value === 1) {
          <h5>Upload Images</h5>
        }
        @if (blogId && form1?.get('type')?.value === 1) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-fileUpload name="files[]" [customUpload]="true" (uploadHandler)="myUploader($event)"
                multiple="multiple" accept=".jpg,.jpeg,.gif" maxFileSize="52428800">
                <ng-template pTemplate="content">
                  @if (uploadedFiles.length) {
                    <ul>
                      @for (file of uploadedFiles; track file) {
                        <li>{{file.name}} - {{file.size}} bytes
                        </li>
                      }
                    </ul>
                  }
                </ng-template>
              </p-fileUpload>
            </span>
          </div>
        }


        @if (!isPicture && blogId && form1?.get('type')?.value === 1) {
          <p-table #pt [value]="pictures" [lazy]="true" (onLazyLoad)="loadLazy($event)"
            dataKey="pictureId" selectionMode="single" [(selection)]="image" (onRowSelect)="onRowSelect($event)"
            [paginator]="true" [rows]="200" [rowsPerPageOptions]="[200,500,1000]" showCurrentPageReport="true"
            currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
            [totalRecords]="recordTotal" sortMode="multiple" [multiSortMeta]="multiSortMeta"
            styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
            [autoLayout]="true" [responsive]="true">
            <ng-template pTemplate="caption">
              <h5>Edit Images</h5>
              <div class="d-block text-end">
                <button pButton pRipple class="p-button-text"
                  style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="unSelectAllPictures()">Unselect All</button>
                <button pButton pRipple class="p-button-text"
                  style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
                  (click)="selectAllPictures()">Select
                All</button>
                @if (forDeletePictures.length > 0) {
                  <span>
                    <!--Delete Checked-->
                    <button pButton pRipple class="p-button"
                      style="background-color:red;padding: 0.643rem 0.75rem !important;"
                    (click)="deleteMultiplePictures()">Delete Checked</button>
                  </span>
                }
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [ngStyle]="{'width': '50px'}"></th>
                @for (col of columns; track col) {
                  <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                }
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
              <tr>
                <th [ngStyle]="{'width': '50px'}"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}"
                pInputText type="text" (input)="pt.filter($event.target.value, 'pictureId', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-image>
              <tr>
                <td>
                  <p-image src="{{generateUrl(image.url)}}" alt="{{image.caption}}" width="400"
                  preview="true"></p-image>
                </td>
                <td>
                  {{image.pictureId}}
                </td>
                <td>
                  <!-- <a>
                  <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
                  (click)="onOpenFormEdit(image)"></i>
                </a> -->
                <a (click)="onDelete(image)"><i class="pi pi-times" aria-hidden="true"
                style="color:red; font-size:110%; padding-right:20px;"></i></a>
                <p-checkbox [(ngModel)]="image.checked" [ngModelOptions]="{standalone: true}"
                  [value]="image.checked" (click)="addIntoCheckedList(image)"
                [binary]="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (blogId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete</button>
            }
          </div>

          <div class="button-group">
            <!-- <a pButton *ngIf="blogId" class="btn-cancel p-button-text"
          href="https://www.kbmresorts.com/blog/details/{{blogId}}/{{gfg()}}" target="_blank">Preview</a> -->
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!blogId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (blogId) {
            <button pButton class="btn-upt p-button" (click)="formUpdate()">Update</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>